import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { SetStorymapAiTemplateOverride as SetStorymapAiTemplateOverrideCommand } from '../../api/commands';
import { useStorymapStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetStorymapAiTemplateOverride extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetStorymapAiTemplateOverride';

    public constructor(
        public libraryTemplateId: string,
        public isVisible: boolean
    ) {
        super(SetStorymapAiTemplateOverride.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetStorymapAiTemplateOverride): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new SetStorymapAiTemplateOverrideCommand(
            state.id,
            action.libraryTemplateId,
            action.isVisible
        ),
    });
};

const reducer = (state: StorymapState, action: SetStorymapAiTemplateOverride): void => {
    const existing = state.aiTemplateOverrides.find(
        (o) => o.libraryTemplateId === action.libraryTemplateId
    );
    if (existing) {
        existing.isVisible = action.isVisible;
    } else {
        state.aiTemplateOverrides.push({
            libraryTemplateId: action.libraryTemplateId,
            isVisible: action.isVisible,
        });
    }
};

//@ts-ignore
registerMiddleware(SetStorymapAiTemplateOverride.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetStorymapAiTemplateOverride.ACTION_TYPE, reducer);
